module.exports = ".navbar-brand {\n  font-family: Papyrus;\n  font-size: x-large;\n  font-style: italic;\n  margin-top: 5px; }\n\n.navbar-subtitle {\n  white-space: nowrap;\n  font-size: large;\n  font-style: italic;\n  margin-top: 5px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.scss
// module id = ./src/app/app.component.scss
// module chunks = main